import { Sheet, SheetContent } from '@e2n/ui';
import { Navigate, Outlet, useParams } from 'react-router-dom';

export function SheetWrapper() {
  const { id } = useParams();

  if (!id) {
    return <Navigate to="/mitarbeiter/rotationsplaene" replace />;
  }

  return (
    <Sheet open={true}>
      <SheetContent
        removeCloseIcon
        className="flex flex-col gap-6 w-full md:min-w-120 p-0 h-full">
        <Outlet />
      </SheetContent>
    </Sheet>
  );
}
